export default {
  namespaced: true,
  state: {
    recent: '',
    product: '',
    relevantReviews: [],
    seeMore: {
      isOpen: false,
      content: '',
      index: 1,
    }
  },
  mutations: {
    EDIT_REVIEW(state, { on, value, reviewId }) {
      this._vm.$SO.each(state[on], (key, review) => {
        if (review._id === reviewId) {
          this._vm.$set(state[on], key, value);
          return false;
        }
      });
    },
    MERGE_REVIEW(state, { on, reviews }) {
      state[on] = state[on].concat(reviews);
    },
    SET_REVIEW(state, { on, reviews }) {
      state[on] = reviews;
    },
    SET_HAS_LIKED(state, { on, value, reviewId }) {
      this._vm.$SO.each(state[on], (key, review) => {
        if (review._id === reviewId) {
          state[on][key].has_liked = value;
          return false;
        }
      });
    },
    SET_HAS_BOOKMARKED(state, { on, value, reviewId }) {
      this._vm.$SO.each(state[on], (key, review) => {
        if (review._id === reviewId) {
          state[on][key].has_bookmarked = value;
          return false;
        }
      });
    },
    SET_RELEVANT_REVIEWS(state, reviews) {
      state.relevantReviews = reviews;
    },
    SET_SEE_MOTE_RELEVANT_REVIEWS(state, { isOpen = false, content = '', index = 1 }) {
      state.seeMore = Object.assign(state.seeMore, { isOpen, content, index });
    }
  },
  actions: {},
};
